const Projects = () => {
    const projects = [
        {
            id: 1,
            title: 'Work The Flow',
            description: 'A productivity app that helps you stay focused and get things done',
            image: '/worktheflow.png',
            technologies: ['macOS', 'Productivity'],
            subdomain: 'wtf'
        }
    ];

    return (
        <section className="projects-section" id="projects">
            <div className="title-container">
                <h2 className="section-title">Projects</h2>
                <p className="section-subtitle">Check out some of our latest work</p>
            </div>
            
            <div className="projects-grid">
                {projects.map((project) => (
                    <div key={project.id} className="project-card">
                        <a href={`https://${project.subdomain}.bitoverloaded.com`} className="project-card-link" target="_blank" rel="noopener noreferrer">
                            <div className="project-image">
                                <img src={project.image} alt={project.title} />
                            </div>
                            <div className="project-content">
                                <h3 className="project-title">{project.title}</h3>
                                <p className="project-description">{project.description}</p>
                                <div className="project-technologies">
                                    {project.technologies.map((tech, index) => (
                                        <span key={index} className="tech-tag">{tech}</span>
                                    ))}
                                </div>
                                <span className="view-project-btn">View Details</span>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Projects; 